import React from 'react';
import { ModuleItemInterface } from '../../../types/home.type';

interface ChatHomeSectionProps {
  module: ModuleItemInterface;
}

const ChatHomeSection: React.FC<ChatHomeSectionProps> = ({ module }) => {
  return (
    <div className="chat-home-section p-4 border rounded-lg shadow-sm" style={{ backgroundColor: module.backgroundColor || 'transparent' }}>
      <h2 className="text-xl font-bold">{module.label}</h2>
      <p>Chat functionality coming soon...</p>
    </div>
  );
};

export default ChatHomeSection;
